import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  descriptionPlaceholder: {
    id: 'studio.PsLpk/',
    defaultMessage: 'Tell us what you think of this app!',
  },
  rateApp: {
    id: 'studio.n9fGMG',
    defaultMessage: 'Rate this app',
  },
  rating: {
    id: 'studio.ETRyBL',
    defaultMessage: 'Rating',
  },
  review: {
    id: 'studio.R+J5ox',
    defaultMessage: 'Review',
  },
  submit: {
    id: 'studio.wSZR47',
    defaultMessage: 'Submit',
  },
});
